"use client"
import { useTranslation } from 'react-i18next'

export const useI18n = () => {
  const { i18n } = useTranslation()

  return {
    currentLanguage: i18n.language,
    changeLanguage: i18n.changeLanguage,
    isReady: i18n.isInitialized
  }
}
